import { z } from "zod";

const CleanBeautyCheck = z.union([z.literal(1), z.literal(0)]);

const CleanBeautyLabelSchema = z.union([
  z.literal("pro_animal"),
  z.literal("pro_vegan"),
  z.literal("pro_nature"),
  z.literal("pro_ocean"),
  z.literal("pro_organic"),
]);

type CleanBeautyLabels = z.infer<typeof CleanBeautyLabelSchema>;

const FreeOfSchema = z.record(CleanBeautyCheck);
const LabelsSchema = z.record(CleanBeautyCheck).transform((labelData) => {
  const result: { [key in CleanBeautyLabels]?: 0 | 1 } = {};
  for (const label in labelData) {
    const resultLabel = CleanBeautyLabelSchema.safeParse(label);
    if (resultLabel.success) {
      result[resultLabel.data] = labelData[label];
    }
  }
  return result;
});
const CleanBeautyAvailable = z.object({
  available: z.literal(1),
  free_of: FreeOfSchema,
  labels: LabelsSchema,
});

const CleanBeautyUnAvailable = z.object({
  available: z.literal(0),
});

const CleanBeautyData = z.union([CleanBeautyAvailable, CleanBeautyUnAvailable]);
const CleanBeautyResponse = z.record(CleanBeautyData);

type CleanBeauty = z.infer<typeof CleanBeautyResponse>;
type FreeOf = z.infer<typeof FreeOfSchema>;
type Labels = z.infer<typeof LabelsSchema>;

export { CleanBeautyData, CleanBeautyResponse, CleanBeautyLabelSchema };

export type { CleanBeauty, CleanBeautyLabels, FreeOf, Labels };
